function upsertPhoneContact(contacts, type, value) {
  const next = [...(contacts || [])];
  const idx = next.findIndex((c) => c.channel === "PHONE" && c.type === type);
  if (idx >= 0) {
    next[idx] = { ...next[idx], value };
  } else {
    next.push({ channel: "PHONE", type, value });
  }
  return next;
}

/** Sync personal mobile fields into contacts when the contacts section is active. */
export function syncPersonalMobileToContacts(patient, field, value) {
  const next = { ...patient, [field]: value };
  if (field === "primaryMobile") {
    next.contacts = upsertPhoneContact(patient.contacts, "PRIMARY", value);
  } else if (field === "secondaryMobile") {
    next.contacts = upsertPhoneContact(patient.contacts, "SECONDARY", value);
  }
  return next;
}
